import { error } from "../actionConstants";

export const hasError = () => ({
  type: error.HAS_ERROR
});

export const hasNoError = () => ({
  type: error.HAS_NO_ERROR
});
